import styled from "styled-components";
import { colors } from "../../../common/ui/globalColors";

export const StyledTenants = styled.div`
    .tenants-title {
        margin-bottom: 9px;
        font-weight: 700;
        font-size: 18px;
        line-height: 25px;
    }

    .tenants-title.margin-top {
        margin-top: 32px;
    }

    .tenants-wrapper {
        display: flex;
        flex-direction: column;
        gap: 14px;

        .tenants-titles {
            display: grid;
            grid-template-columns: 0.5fr 2fr 2fr 2fr 2fr;
            font-weight: 700;
            font-size: 14px;
            line-height: 25px;
            color: ${colors.semiTransparentColors.grayBlue};
            text-align: center;
            gap: 5px;
            padding: 0 40px;
        }
    }
`